//styles/headerStyles.js
export const headerContainer = (theme) => ({
  backgroundColor: theme.palette.background.default,
  boxShadow: theme.shadows[0],
  borderBottom: `1px solid transparent`,
  color: theme.palette.text.primary
});

export const headerLink = (theme) => ({
  display: { xs: "none", md: "flex" },
  color: theme.palette.text.primary,
  textDecoration: "none",
  mx: 1,
  "&:hover": {
    textDecoration: "underline",
  },
});

export const mobileMenuIcon = {
  display: { xs: "flex", md: "none" },
};

export const desktopMenu = {
  display: { xs: "none", md: "flex" },
  alignItems: "center",
};

export const drawerListItem = (theme) => ({
  color: theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.background.subtle,
  },
});

export const drawerLanguageItem = {
  display: "flex",
  alignItems: "center",
};
